export const appsAppGroupIdChartsBanner = "/apps/:app_group_id/charts/banner";
